import InvoiceList from './InvoiceList';
import InvoiceCreate from './InvoiceCreate';
import InvoiceShow from './InvoiceShow';

const invoices = {
	list: InvoiceList,
	create: InvoiceCreate,
	show: InvoiceShow
};

export default invoices;
